export default class TaskStatuses {
  static TO_DO = "toDo";

  static IN_PROGRESS = "inProgress";

  static ON_HOLD = "onHold";

  static COMPLETED = "completed";
}
